module.exports = __webpack_public_path__ + "static/pointer-2.b3410cb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pointer-2.svg
// module id = 450
// module chunks = 35783957827783 172322841747965